import PropTypes from "prop-types";
import { Card, Divider } from "@mantine/core";
import { HiOutlineExclamationTriangle } from "react-icons/hi2";
import CustomBadge from "../../../ui/CustomBadge/CustomBadge";
import CustomInlineBanner from "../../../ui/CustomInlineBanner/CustomInlineBanner";
import { CustomText } from "../../../ui/CustomText/CustomText";
import { formatKES, getDisplayValue } from "../../../../utils/transactionutils";
import { balanceErrorBannerStyle } from "../styles/manualEntryStyles";

export default function BatchSummaryCard({
  walletBalance,
  isBalanceError,
  totalDisbursement,
  totalRecipients,
  totalCharges,
  totalPlusFees,
}) {
  const isInsufficient = walletBalance !== null && totalPlusFees > walletBalance;

  return (
    <Card radius="lg" className="p-5 sm:p-6 w-full md:flex-1 md:max-w-[320px]">
      <div className="flex items-center justify-between mb-5">
        <span className="text-sm text-gray-500 font-medium">Batch Summary</span>
        <CustomBadge variant="light" color="primary" size="sm">
          Manual
        </CustomBadge>
      </div>

      {/* Wallet Balance */}
      <div className="mb-4">
        <p className="text-xs text-gray-500 mb-1">Wallet Balance</p>
        {isBalanceError ? (
          <CustomInlineBanner
            styles={balanceErrorBannerStyle}
            icon={<HiOutlineExclamationTriangle size={14} />}
            className="mt-2"
          >
            <p className="text-xs text-orange-700">
              Unable to validate merchant balance. You may still proceed.
            </p>
          </CustomInlineBanner>
        ) : (
          <>
            <p className="text-xl font-bold text-primary-600">
              {formatKES(walletBalance)}
            </p>
            {isInsufficient && (
              <CustomText size="xs" c="red" mt={4}>
                Batch total exceeds your wallet balance
              </CustomText>
            )}
          </>
        )}
      </div>

      <div className="mb-4">
        <p className="text-xs text-gray-500 mb-1">Total Disbursement Amount</p>
        <p className="text-xl font-bold text-gray-900">
          {formatKES(totalDisbursement)}
        </p>
      </div>

      <Divider />

      <div className="flex items-center justify-between py-3">
        <span className="text-sm text-gray-500">Total Recipients</span>
        <span className="text-sm font-medium text-gray-900">
          {getDisplayValue(totalRecipients)}
        </span>
      </div>

      <Divider />

      <div className="flex items-center justify-between py-3">
        <span className="text-sm text-gray-500">Total Charges</span>
        <span className="text-sm font-medium text-gray-900">
          {formatKES(totalCharges)}
        </span>
      </div>

      <Divider />

      <div className="flex items-center justify-between py-3">
        <span className="text-sm font-semibold text-gray-900">
          Total + Fees
        </span>
        <span className="text-sm font-bold text-primary-600">
          {formatKES(totalPlusFees)}
        </span>
      </div>
    </Card>
  );
}

BatchSummaryCard.propTypes = {
  walletBalance: PropTypes.number,
  isBalanceError: PropTypes.bool,
  totalDisbursement: PropTypes.number,
  totalRecipients: PropTypes.number,
  totalCharges: PropTypes.number,
  totalPlusFees: PropTypes.number,
};
